<template>
  <div>
    <v-stepper vertical v-model="step" class="px-md-10 px-0">

      <v-stepper-step step="1">
        مرحله ۱
        <small>نوع سفارش</small>
      </v-stepper-step>
      <v-stepper-content step="1" class="mx-0 px-1 pr-2">
        <h5 class="pb-5 text-center"> {{ pageTitle }}</h5>
        <div class="m-3">
          <v-text-field outlined
                        dense
                        v-model="data.organizationName"
                        hint="لطفا نام مجموعه خود را وارد کنید."
                        maxLength="50"
                        counter="50"
                        :rules="this.$rules.requiredString"
                        label="نام مجموعه "
                        append-icon="mdi-domain"/>
        </div>
        <div class="m-3">
          <v-text-field outlined
                        dense
                        v-model="data.brandName"
                        hint="لطفا نام برند خود را  وارد  کنید."
                        maxLength="50"
                        counter="50"
                        :rules="this.$rules.requiredString"
                        label="نام برند "
                        append-icon="mdi-domain"/>
        </div>
        <div class="m-3">
          <v-text-field outlined
                        v-model="data.brandSlogan"
                        dense
                        hint="لطفا شعار برند خود را وارد نمایید"
                        placeholder="لطفا شعار برند خود را وارد نمایید"
                        maxLength="50"
                        counter="50"
                        label="شعار برند"
                        append-icon="mdi-domain"/>
        </div>
        <div class="m-3">
          <v-switch
              v-model="data.slogan"
              dense
              class="text-right"
              label="میخواهم شعار در بنر اضافه شود"
          ></v-switch>
        </div>
        <v-btn class="submit-btn" @click="step1Validate">
          ادامه
          <span class="fa fa-arrow-left mr-1"></span>
        </v-btn>
      </v-stepper-content>

      <v-stepper-step step="2">
        مرحله ۲
        <small>اطلاعات اولیه سفارش</small>
      </v-stepper-step>
      <v-stepper-content class="mx-0 px-1 pr-2" step="2">
        <div class="mt-2">
          <div>
            <v-expansion-panels class="px-1">
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا نوع سفارش خودرا انتخاب کنید

                  <div class="row mr-2" v-if="!isMobile">
                    <div v-if="data.orderType">
                      <v-chip
                          v-if="data.orderType"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ orderType.find((x) => x.value === data.orderType).text }}
                      </v-chip>
                    </div>
                    <div v-if="data.orderType==='designPrint' && data.printCount">
                      <v-chip
                          v-if="data.printCount"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ data.printCount|currency|persianNum }} عدد
                      </v-chip>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.orderType && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-autocomplete
                      class="m-1"
                      v-model="data.orderType"
                      :items="orderType"
                      dense
                      item-text="text"
                      item-value="value"
                      label="نوع سفارش"
                      placeholder="لطفا یک گزینه را انتخاب نمایید."
                      hint="لطفا یک گزینه را انتخاب نمایید."
                      outlined
                  ></v-autocomplete>
                  <v-text-field
                      v-if="data.orderType==='designPrint'"
                      class="m-1"
                      v-model="printCounting"
                      dense
                      @keypress="allowOnlyNumbers"
                      item-text="text"
                      item-value="value"
                      label="تعداد چاپ"
                      placeholder="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                      hint="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                      outlined
                  ></v-text-field>
                  <v-autocomplete
                      v-if="data.type==='visit_card'"
                      class="m-1"
                      :items="printType"
                      dense
                      item-text="text"
                      item-value="value"
                      label="نوع طرح"
                      placeholder="لطفا یک گزینه را انتخاب نمایید."
                      hint="لطفا یک گزینه را انتخاب نمایید."
                      outlined
                  ></v-autocomplete>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel class="mb-4 px-1 customStyle">
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا رنگ بنر را انتخاب نمایید.
                  <div v-if="data.color.length>0 && !isMobile">
                    <v-chip
                        v-if="data.color.length>0"
                        v-for="color in data.color"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        :color="color"
                        class="mx-2"
                        outlined
                        dense
                    >{{ color }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.color.length>0 && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <color-pickers :count="2" v-model="data.color" class="mb-4"></color-pickers>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا نوع بنر خود را انتخاب نمایید.

                  <div class="row mr-2" v-if="!isMobile">
                    <div v-if="data.bannerType">
                      <v-chip
                          v-if="data.bannerType"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ names['bannerType'] }}
                      </v-chip>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.bannerType && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <banner-type @persianName="persianName" v-model="data.bannerType"
                               class="mb-4"></banner-type>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا سایز بنر خود را تایپ نمایید.
                  <div class="row mr-2" v-if="!isMobile">
                    <div v-if="data.orientation">
                      <v-chip
                          v-if="data.orientation"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ data.orientation === 'horizontal' ? 'افقی' : 'عمودی' }}
                      </v-chip>
                    </div>
                    <div v-if="data.preferredUnit">
                      <v-chip
                          v-if="data.preferredUnit"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ data.preferredUnit === 'mm' ? 'میلی متر' : 'سانتی متر' }}
                      </v-chip>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.width && data.length && isMobile" color="teal">mdi-check
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-text-field
                        class="m-1"
                        v-model="data.width"
                        dense
                        item-text="text"
                        item-value="value"
                        label="عرض بنر"
                        @keypress="allowOnlyNumbers"
                        placeholder="لطفا عرض بنر موردنظر را واردکنید."
                        hint="لطفا عرض بنر موردنظر را واردکنید."
                        outlined
                    ></v-text-field>
                    <v-text-field
                        class="m-1"
                        v-model="data.length"
                        dense
                        item-text="text"
                        item-value="value"
                        label="طول بنر"
                        @keypress="allowOnlyNumbers"
                        placeholder="لطفا طول بنر موردنظر را واردکنید."
                        hint="لطفا طول بنر موردنظر را واردکنید."
                        outlined
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-radio-group class="mt-0 text-right px-0 mx-0 pt-0" row
                                   v-model="data.orientation">
                      <v-radio
                          value="vertical"
                      >
                        <template v-slot:label>
                          <img src='@/assets/double-arrow-vertical-symbol.png' class=""
                               width="20" alt="">
                          <span>عمودی</span>
                        </template>
                      </v-radio>
                      <v-radio
                          label="افقی"
                          value="horizontal"
                          class="my-2"
                      >
                        <template v-slot:label>
                          <img src='@/assets/double-arrow-horizontal-symbol.png' width="20"
                               class="ml-2" alt="">
                          <span>افقی</span>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-radio-group
                        :class="isMobile?'mt-0 text-right px-0 mx-0 pt-0':'mt-0 text-left pr-10 mr-auto pt-0'"
                        row v-model="data.preferredUnit">
                      <v-radio
                          label="سانتی متر"
                          value="cm"
                      ></v-radio>
                      <v-radio
                          label="میلی متر"
                          value="mm"
                      ></v-radio>

                    </v-radio-group>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا اطلاعات بنر خود را تایپ نمایید.
                  <div class="mr-2" v-if="data.distanceSeen">
                    <v-chip
                        v-if="data.distanceSeen"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ data.distanceSeen }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.distanceSeen && data.bannerContacts && isMobile"
                            color="teal">mdi-check
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div :class="isMobile ? 'px-0 mx-0' : 'm-1 px-0 row' ">
                    <v-text-field
                        :class="isMobile?'' : 'ml-2'"
                        v-model="data.distanceSeen"
                        dense
                        @keypress="allowOnlyNumbers"
                        label="فاصله دید بنر"
                        placeholder="بنرتان معمولا از چه فاصله ای دیده می شود؟"
                        hint="بنرتان معمولا از چه فاصله ای دیده می شود؟"
                        outlined
                    ></v-text-field>
                    <v-text-field
                        v-model="data.bannerContacts"
                        dense
                        label="مخاطبین بنر"
                        placeholder="مخاطبین بنر معمولا چه کسانی هستند؟"
                        hint="مخاطبین بنر معمولا چه کسانی هستند؟"
                        outlined

                    ></v-text-field>
                  </div>
                  <p>
                    لطفا محتوای متنی که قراراست در داخل بنرتان درج شود را تایپ نمایید
                  </p>
                  <V8Editor :class="isMobile? '' : 'mx-2' "
                            v-model="data.bannerText"/>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا طراحی پایه بنر خود را مشخص نمایید.

                  <div class="row mr-2" v-if="!isMobile">
                    <div v-if="data.baseLayer">
                      <v-chip
                          v-if="data.baseLayer"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ names['firstLayer'] }}
                      </v-chip>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.baseLayer && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <first-layer @persianName="persianName" v-model="data.baseLayer"
                               class="mb-4"></first-layer>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا ساختار کلی بنر خود را مشخص نمایید.

                  <div class="row mr-2" v-if="!isMobile">
                    <div v-if="data.generalStructure">
                      <v-chip
                          v-if="data.generalStructure"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ names['generalStructure'] }}
                      </v-chip>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.generalStructure && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <general-structure @persianName="persianName" v-model="data.generalStructure"
                                     class="mb-4"></general-structure>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

        </div>
        <div class="row justify-content-between py-2 mx-auto">
          <v-btn class="submit-btn col-md-1 col-3" @click="step2Validate">
            ادامه
            <span class="fa fa-arrow-left mr-1"></span>
          </v-btn>
          <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 1">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-step step="3">
        مرحله ۳
        <small>مشخصات سایت</small>
      </v-stepper-step>
      <v-stepper-content class="mx-0 px-1 pr-2" step="3">
        <div class="mt-2" v-if="step===3">
          <div>
            <span class="text-center pb-2">لطفا عکس یک یا چندبنر مورد علاقه خود را برای ما ارسال کنید. تا تیم طراحی ما نیاز شما را بهتر درک کنند.</span>
          </div>
          <v-file-input
              v-model="data.file"
              label=" بارگذاری عکس "
              outlined
              accept="image/png, image/jpeg,image/jpg, image/bmp"
              placeholder="عکس موردنظر خود را بارگذاری کنید."
              hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
              prepend-inner-icon="mdi-camera"
              clearable
              small-chips
              clear-icon="mdi-close-circle-outline"
              prepend-icon=""
              dense
              multiple
              class="mt-1 pt-1"
          >
          </v-file-input>

          <div>
            <span class="text-center pb-2">لطفا لوگو برند خودرابارگذاری کنید</span>
          </div>
          <v-file-input
              v-model="data.brandLogo"
              label=" بارگذاری عکس "
              outlined
              accept="image/png,image/jpeg"
              placeholder="لطفا لوگو برند خودرابارگذاری کنید."
              hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
              prepend-inner-icon="mdi-camera"
              clearable
              small-chips
              multiple
              clear-icon="mdi-close-circle-outline"
              prepend-icon=""
              dense
              class="mt-1 pt-1"
          >
          </v-file-input>

          <div>
            <date-picker
                v-model="data.deliveryTime"
                color="#00acc1"
                label="زمان تحویل"
                input-class="mb-0 rounded"
                persianDigits
                clearable
                :timezone="false"
                format="YYYY-MM-DD"
                style="font-size: 13px!important"
                class="dateSet"
                display-format="jMMMM jD"
                :min="countDay"
            />
          </div>
          <div class="mt-5">
            <v-text-field outlined
                          dense
                          v-model="data.businessDescription"
                          hint="لطفا درمورد حوزه کسب وکارخود توضیح دهید."
                          maxLength="50"
                          counter="50"
                          :rules="this.$rules.requiredString"
                          label="حوزه کسب وکار "
                          append-icon="mdi-domain"/>
          </div>
        </div>

        <div class="row justify-content-between py-2 mx-auto">
          <v-btn class="submit-btn col-md-1 col-3" @click="step3Validate">
            ادامه
            <span class="fa fa-arrow-left mr-1"></span>
          </v-btn>
          <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 2">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-step step="4">
        مرحله ۴
        <small>زمان تحویل</small>
      </v-stepper-step>
      <v-stepper-content class="mx-0 px-1 pr-2" step="4">

        <div class="mt-1">
          <div class="mb-2">
            <span class="text-center pb-2">لطفا توضیحات تکمیلی خود در مورد نیازتان را برای متخصصان ما یادداشت نمایید، تا بتوانیم به بهترین شکل ممکن درخواست شما را بررسی و پاسخ دهیم.</span>
          </div>

          <V8Editor class="pt-4" v-model="data.description"/>
        </div>

        <div class="row justify-content-between py-2 mx-auto">
          <v-btn :loading="loading" class="submit-btn col-md-1 col-4 mt-5" @click="submit">
            <span class="fa fa-save mr-1"></span>
            ثبت سفارش
          </v-btn>
          <v-btn class="mx-4 mt-5 btn-refund col-md-1 col-4" @click="step = 3">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>

    </v-stepper>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "../../../../core/plugins/CKEditorUploadFileAdapter";
import BannerType from "@/view/pages/site/banner/components/bannerType";
import FirstLayer from "@/view/pages/site/banner/components/firstLayer";
import GeneralStructure from "@/view/pages/site/banner/components/generalStructure";
import ColorPickers from "@/view/pages/components/colorPickers";
import {createFormData} from "../../../../Utilities/FormRequestHelper";

export default {
  name: "bannerStepper",
  components: {
    ColorPickers,
    GeneralStructure,
    FirstLayer,
    BannerType,
  },
  data() {
    return {
      step: 1,
      days: '',
      marker: true,
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          language: 'fa',
          contentsLangDirection: 'rtl',
          extraPlugins: [CKEditorUploadAdapterPlugin],
        }
      },
      mainPrice: "",
      dialogPayment: false,
      designs: false,
      type: 'banner',
      payDialogInfo: {},
      orderType: [
        {text: 'فقط طراحی', value: 'design'},
        {text: 'طراحی به همراه چاپ', value: 'designPrint'},
      ],
      printType: [
        {text: 'فقط طراحی', value: 'design'},
        {text: 'طراحی به همراه چاپ', value: 'designPrint'},
      ],

      payableTransaction: null,
      brandSlogan: null,
      selectedRows: [],
      paymentLoading: false,
      data: {
        organizationName: null,
        brandName: null,
        slogan: 0,
        brandLogo: [],
        orderType: null,
        bannerType: null,
        brandSlogan: null,
        description: null,
        length: '',
        width: null,
        size: 'A3',
        file: [],
        preferredCurrency: 'Rial',
        user_price: null,
        distanceSeen: null,
        color: [],
        headerTexts: null,
        businessDescription: null,
        printCount: null,
        orientation: "vertical",
        bannerContacts: null,
        bannerText: null,
        baseLayer: null,
        generalStructure: null,
        deliveryTime: null,
        preferredUnit: 'cm',
        hasBrandSlogan: false,
      },
      orderTypes: [
        {key: 'banner', keyAlias: 'طراحی بنر', icon: '/media/site/aparat.png'},
      ],
      errors: [],
      dialog: false,
      loading: false,
      rules: [
        v => !!v || 'وارد کردن این فیلد الزامی است'
      ],
      urlRules: [
        (value) => this.isURL(value) || "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      ],
      errorMsg: '',
      nameErr: '',
      pageTitle: '',
      userWallet: [],
      dialogInfo: null,
      tab: null,
      items: [
        'سفارش ها',
        'ثبت سفارش جدید',
      ],
      userInfo: {},
      names: {},
      statusBadge: '',
      userValid: true,
      isRejected: false,
      isPending: false,
      articleDesc: false,
      enterMine: false,
      userInfoGot: false
    }
  },
  methods: {
    persianName(name, field) {
      this.names[field] = name
    },
    isURL(str) {
      var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
      var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
      if (regex.test(str) || without_regex.test(str)) {
        return true
      } else {
        return false;
      }
    },
    paymentDialog(data) {
      this.payDialogInfo = data
      this.dialogPayment = true
    },
    step1Validate() {
      if (!this.data.organizationName || !this.data.brandName) {
        this.$toast.error('نام برند و نام مجموعه الزامی است.')
        return
      } else if (this.data.hasBrandSlogan && !this.data.brandSlogan) {
        this.$toast.error('شعار برند خودرا بنویسید.');
        return
      } else if (this.data.slogan && !this.data.brandSlogan) {
        this.$toast.error('لطفا شعار برند خودرا وارد کنید.')
      } else
        this.step = 2
    },
    step2Validate() {
      if (this.type === 'banner') {
        const banner = [
          {main: this.data.orderType, name: 'نوع سفارش '},
          {main: this.data.color, name: 'رنگ '},
          {main: this.data.bannerType, name: 'نوع '},
          {main: this.data.size, name: 'سایز'},
          {main: this.data.width, name: 'عرض '},
          {main: this.data.length, name: 'طول '},
          {main: this.data.distanceSeen, name: 'فاصله دید '},
          {main: this.data.bannerContacts, name: 'مخاطبین '},
          {main: this.data.bannerText, name: 'محتوای متنی '},
          {main: this.data.orientation, name: 'جهت '},
          {main: this.data.baseLayer, name: 'طراحی پایه '},
          {main: this.data.generalStructure, name: 'ساختارکلی '},

        ]

        for (let val of banner) {
          if (val.main === null || val.main.length <= 0) {
            this.$toast.error(val.name + 'بنر ' + 'الزامی است.');
            return;
          }
        }

        if (this.data.orderType === 'designPrint' && !this.data.printCount)
          this.$toast.error('تعداد چاپ الزامی است.');
        else
          this.step = 3;
      }
    },
    step3Validate() {
      const banner = [
        {main: this.data.brandLogo, name: 'لوگوبرند '},
        {main: this.data.deliveryTime, name: 'زمان تحویل '},
        {main: this.data.businessDescription, name: 'حوزه کسب و کارتان '},
      ]
      for (let val of banner) {
        if (val.main === null || val.main.length <= 0) {
          this.$toast.error(val.name + 'الزامی است.');
          return;
        }
      }
      this.step = 4
    },
    submit() {
      this.errors = [];

      this.loading = true
      this.requestApiPost(`form/graphic/banner`, createFormData(this.data))
          .then((res) => {
            if (res.status && res.status === 201) {
              this.loading = false;
              this.$emit('eventname', 1)
              this.$toast.success('با موفقیت ثبت شد.');
            } else {
              this.loading = false;
              this.$toast.warning('لطفا مجددا تلاش کنید')
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$toast.error(Object.values(e.response.data.errors).map((x) => {
              return x.join('\n');
            }).join(''));

            this.errors = e.response.data.errors
          })
          .finally(() => {
            this.loading = false;
            this.$modal.hideLoading();
          })
    },
    pay(transactionId) {
      if (this.payDialogInfo.payments.type === 'final') {

        this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: this.payDialogInfo.payments.transactions[0].id})
            .then(response => {
              this.$toast.success('با موفقیت پرداخت شد!')
              this.getSites()
              this.dialogPayment = false
            }).catch(({res}) => {
          this.loading = false
          this.$toast.error(res.data.message)
        })


      } else {
        this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: transactionId})
            .then(response => {
              this.$toast.success('با موفقیت پرداخت شد!')
              this.getSites()
              this.dialogPayment = false
            }).catch(({res}) => {
          this.loading = false
          this.$toast.error(res.data.message)
        })

      }
    },
    getSites(url = this.url, params = this.tableProps) {
      this.$modal.showLoading();
      this.requestApiGet(url, params).then(response => {
        this.userInfo = response.data;
      }).finally(() => {
        this.$modal.hideLoading();
        if (!this.userInfoGot) {
          this.getUserInfo();
        }
      })
    },
    edit(data) {
      this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
    },
    information(data) {
      this.$router.push({name: 'admin.users.information', params: {id: data.id}})
    },
    checkRoutes() {
      this.pageTitle = this.orderTypes[0].keyAlias;

    },
    changeUnit() {
      this.marker = !this.marker;
      if (this.marker) {
        this.data.preferred_currency = 'Rial'
      } else this.data.preferred_currency = 'Toman'
    }
  },
  watch: {
    'data.name': function (value) {
      var regex = /^[a-zA-Z]+$/;
      if (value > 3 && !value.match(regex)) {
        this.nameErr = 'نام مجموعه نمیتواند تنها شامل اعداد باشد.'
      } else
        this.nameErr = '';
    },
    'data.slogan': function (value) {
      if (value) {
        this.data.slogan = 1
      } else this.data.slogan = 0
    }
  },
  computed: {
    main_price: {
      get() {
        return this.$options.filters.currency(this.data.user_price)
      },
      set(value) {
        this.data.user_price = value.replaceAll(',', '')
      }
    },
    printCounting: {
      set(value) {
        this.data.printCount = value * 1000;
      },
    },
    countDay: {
      get() {
        const minimum_day = new Date();
        minimum_day.setDate(minimum_day.getDate() + 5);
        return minimum_day;
      },
    }
  },
  mounted() {
    this.checkRoutes();
  }
}
</script>

<style scoped>

</style>